<script>
import Glide from "@glidejs/glide";

  export default {
    data() {
      return {
        tabIndex: 1,
      };
    },
    methods: {
      setIndex(index) {
        this.tabIndex = index
      },
    },
    render(h) {
      return this.$scopedSlots.default({
        setIndex: this.setIndex,
        tabIndex: this.tabIndex
      });
    },
  };  
</script>
